// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  FETCH_COUNTRIES: `${env.baseApiUrl}/im/location/country`,
  // GET_STORE_COUNTRY: `${env.baseApiUrl}/winehouse/admin/country/store`,
  GET_STORE_COUNTRY: `${env.baseApiUrl}/im/admin/country`,
  SAVE_STORE_COUNTRY: `${env.baseApiUrl}/im/admin/country`,
});

export const fetchCountriesApi = getCreator(endpoints.FETCH_COUNTRIES);
export const getStoreCountryApi = getCreator(endpoints.GET_STORE_COUNTRY);
export const saveStoreCountryApi = postCreator(endpoints.SAVE_STORE_COUNTRY);
